// Gerador central de URLs públicas do Caseirinho.
// Produção: definir REACT_APP_PUBLIC_BASE_URL=https://caseirinho.pt no build.
// DEV/TEST: sem a variável, usa automaticamente o domínio de preview/deploy atual.
// Nenhum domínio fica hard-coded; ao mudar o domínio, os links adaptam-se sozinhos.

export function publicBaseUrl() {
    const env = process.env.REACT_APP_PUBLIC_BASE_URL || process.env.REACT_APP_APP_BASE_URL;
    if (env) return env.replace(/\/+$/, "");
    if (typeof window !== "undefined" && window.location) return window.location.origin.replace(/\/+$/, "");
    return "";
}

// Motor 1 — Produtor indica Produtor
export const producerReferralLink = (code) => (code ? `${publicBaseUrl()}/fornecedores/registo?ref=${code}` : "");

// Motor 2 — Cliente indica Cliente
export const customerReferralLink = (code) => (code ? `${publicBaseUrl()}/r/${code}` : "");

// Motor 3 — Afiliado Profissional
export const affiliateLink = (code) => (code ? `${publicBaseUrl()}/?via=${code}` : "");

// Deep link de produto com atribuição de afiliado
export const productDeepLink = (slug, code) =>
    `${publicBaseUrl()}/produto/${slug}${code ? `?via=${code}` : ""}`;
